import i18n from '@/locale';

export const GENDER_TYPES = [
	{ id: 0, name: i18n.t('common.male') },
	{ id: 1, name: i18n.t('common.female') },
];

export const COMMITTEE_KEYS = {
	vtoken: 'committeeToken',
	vuser: 'committeeMember'
}
